import React from "react";
import {
  Button,
  Modal,
  Icon,
  Header,
  Card,
  Image,
  Divider,
  Container
} from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import { getAccount } from "shared/selectors";
import { bool } from "prop-types";
import { connect } from "react-redux";

function UpscaleCardGroup({ enableAffiliates }) {
  const modalActions = (
    <Modal.Actions>
      <Button
        as="a"
        href="https://upscale.ch/lp01"
        target="_upscale_ch"
        basic
        icon
        labelPosition="right"
      >
        <FormattedMessage id="affiliates.upscale.clickbait" />
        <Icon name="right arrow" />
      </Button>
      <span />
    </Modal.Actions>
  );
  const glamCard = (
    <Card link>
      <Image fluid src="/affiliates/glam_thumb.png" />
    </Card>
  );
  const modernCard = (
    <Card link>
      <Image fluid src="/affiliates/modern_thumb.png" />
    </Card>
  );
  const scandinavianCard = (
    <Card link>
      <Image fluid src="/affiliates/scandinavian_thumb.png" />
    </Card>
  );

  return (
    enableAffiliates && (
      <div>
        <Divider horizontal clearing fitted>
          <Header size="large">
            <FormattedMessage id="affiliates.upscale.title" />
          </Header>
        </Divider>
        <Container text>
          <FormattedMessage id="affiliates.upscale.content" />
        </Container>
        <Divider hidden clearing />
        <Card.Group itemsPerRow={3}>
          <Modal trigger={glamCard} centered={false}>
            <Modal.Header>Glam</Modal.Header>
            <Modal.Content image>
              <Image src="/affiliates/glam.png" />
            </Modal.Content>
            <Modal.Description>
              <Container text>
                <Header>
                  <FormattedMessage id="affiliates.upscale.title" />
                </Header>
                <FormattedMessage id="affiliates.upscale.content" />
                <Divider hidden />
              </Container>
            </Modal.Description>
            {modalActions}
          </Modal>
          <Modal trigger={modernCard} centered={false}>
            <Modal.Header>Modern</Modal.Header>
            <Modal.Content image>
              <Image src="/affiliates/modern.png" />
            </Modal.Content>
            <Modal.Description>
              <Container text>
                <Header>
                  <FormattedMessage id="affiliates.upscale.title" />
                </Header>
                <FormattedMessage id="affiliates.upscale.content" />
                <Divider hidden />
              </Container>
            </Modal.Description>
            {modalActions}
          </Modal>
          <Modal trigger={scandinavianCard} centered={false}>
            <Modal.Header>Scandinavian</Modal.Header>
            <Modal.Content image>
              <Image src="/affiliates/scandinavian.png" />
            </Modal.Content>
            <Modal.Description>
              <Container text>
                <Header>
                  <FormattedMessage id="affiliates.upscale.title" />
                </Header>
                <FormattedMessage id="affiliates.upscale.content" />
                <Divider hidden />
              </Container>
            </Modal.Description>
            {modalActions}
          </Modal>
        </Card.Group>
        <Divider hidden clearing section />
      </div>
    )
  );
}

UpscaleCardGroup.propTypes = {
  enableAffiliates: bool.isRequired
};

function mapStateToProps(state) {
  return {
    enableAffiliates: getAccount(state).isEnabled("enable_affiliates")
  };
}

export default connect(mapStateToProps)(UpscaleCardGroup);
